// src/components/Topics.js
import React from 'react';
import topics from '../data/topics.json'

const Topics = () => {
    const sessions = [
        {
        icon: 'fas fa-tools',
        title: 'Workshops and Skill-Building Sessions',
        description: 'Hands-on sessions designed to enhance participants\' understanding and application of AI tools in social research.'
        },
        {
        icon: 'fas fa-chalkboard',
        title: 'Poster Sessions and Networking',
        description: 'Interactive research presentations and professional networking opportunities'
        }
    ];

  return (
    <section id="topics" className="topics-section">
      <div className="container">
        <div className="section-header fade-in">
          <h2><i className="fas fa-brain me-2"></i>Conference Topics</h2>
        </div>
        <div className="row">
          {topics.map((topic, index) => (
            <div className="col-lg-4 mb-4" key={index}>
              <div className="topic-card fade-in">
                <i className={`${topic.icon} topic-icon`}></i>
                <h3>{topic.title}</h3>
                <p>{topic.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="section-header fade-in mt-5">
            <h2 className="lead">Special Sessions</h2>
        </div>
        <div className="row">
            {sessions.map((topic, index) => (
                <div className="col-lg-6 mb-4" key={index}>
                <div className="topic-card fade-in">
                    <i className={`${topic.icon} topic-icon`}></i>
                    <h3>{topic.title}</h3>
                    {/* <p>{topic.description}</p> */}
                </div>
                </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Topics;